import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { DimensionConfirmDelete } from "./_DimensionConfirmDelete";
import { DimensionDisplay } from "./_DimensionDisplay";

type TProps = {
  dimension: TOrganizationProjectDimension;
  isConfirming: boolean;
  isThisDeleting: boolean;
  otherDeleting: boolean;
  onEdit: () => void;
  onAskDelete: () => void;
  onConfirmDelete: () => void;
  onCancelDelete: () => void;
};

export function DimensionRow(props: TProps) {
  const {
    dimension,
    isConfirming,
    isThisDeleting,
    otherDeleting,
    onEdit,
    onAskDelete,
    onConfirmDelete,
    onCancelDelete
  } = props;

  return (
    <div
      className={cn(
        "flex items-center justify-between gap-3 rounded-lg bg-white px-4 py-3 ring-1 ring-inset ring-[#f4f4f5] transition-opacity",
        (isThisDeleting || otherDeleting) && "pointer-events-none opacity-50"
      )}
    >
      {isConfirming ? (
        <DimensionConfirmDelete
          name={dimension.name}
          isThisDeleting={isThisDeleting}
          onConfirmDelete={onConfirmDelete}
          onCancelDelete={onCancelDelete}
        />
      ) : (
        <DimensionDisplay dimension={dimension} onEdit={onEdit} onAskDelete={onAskDelete} />
      )}
    </div>
  );
}
